<template>
  <v-card>
    <v-card-text>
      <v-form
          ref="ru_form"
          v-model="validationRules.valid"
          lazy-validation
      >
        <v-row>
          <v-col cols="12" sm="12">
            <v-text-field
                dense
                outlined
                readonly
                :value="displaySalePrice"
                label="Sale Price"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-autocomplete
                v-model="editedItem.owner_ids"
                :items="ownersFilter"
                item-text="full_name"
                item-value="id"
                dense
                outlined
                deletable-chips
                chips
                :loading="isOwnersLoaded"
                small-chips
                multiple
                :search-input.sync="ownersSearch"
                :readonly="readonly"
                :disabled="readonly"
                :rules="readonly ? [] : validationRules.multipleRules"
                label="Buyer(s) * (min. 3 characters required)"
                @change="onOwnersSelectionChange"
                @keyup="ownersFilterKeyUp"
                @focus="preloadOwnersFilter"
            >
              <template v-slot:append-outer v-if="!readonly">
                <a target="_blank" href="/contacts-management/contacts?addModule=true">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </a>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title>
                                          <h6>
                                            <span>{{ data.item.full_name }}</span>
                                            <v-chip
                                                v-if="Number(data.item.is_verified) === 1"
                                                x-small
                                                color="success"
                                                class="ml-1"
                                                dark
                                            >Verified</v-chip>
                                          </h6>
                                          <p v-if="data.item.uid">ID: {{ String(data.item.uid).toUpperCase() }}</p>
                      <p>Phone(s):- {{ data.item.contact_phone_titles }}</p>
                      <p>Email(s):- {{ data.item.contact_email_titles }}</p>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
          <!-- Payment Plan hidden on reserve — kept for reference
          <v-col cols="12" sm="12">
            <v-autocomplete
                v-model="editedItem.payment_plan_id"
                :items="item.payment_plans"
                item-text="title"
                item-value="id"
                dense
                outlined
                deletable-chips
                chips
                small-chips
                :rules="isAgencyUser ? validationRules.selectRule : []"
                label="Payment Plan"
            >
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.title"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title>
                      <h6>{{ 'Title: ' + data.item.title }}</h6>
                      <p>{{ 'Down Payment: ' + (data.item.down_payment ? data.item.down_payment + '%' : 'N/A') }}</p>
                      <p>{{ 'Payment At Handover: ' + (data.item.payment_at_handover ? data.item.payment_at_handover + '%' : 'N/A') }}</p>
                      <p>{{ 'Payment After Handover: ' + (data.item.payment_after_handover ? data.item.payment_after_handover + '%' : 'N/A') }}</p>
                      <p>{{ 'Payment During Construction: ' + (data.item.payment_during_construction && data.item.payment_during_construction != 0 ? data.item.payment_during_construction + '%' : 'N/A') }}</p>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
          -->
          <v-col cols="12" sm="4">
            <v-text-field
                dense
                outlined
                :readonly="readonly"
                :rules="readonly ? [] : validationRules.blockingAmountRules"
                v-model="editedItem.unit_blocking_amount"
                maxLength="20"
                @keyup="editedItem.unit_blocking_amount = addTS($event)"
                @keypress="isWholeNumber($event)"
                label="Unit Blocking Amount *"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
                dense
                outlined
                v-model="editedItem.down_payment"
                maxLength="20"
                :readonly="readonly"
                @keyup="editedItem.down_payment = addTS($event)"
                @keypress="isNumber($event)"
                label="Down Payment"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
                dense
                outlined
                v-model="editedItem.remaining_payment"
                maxLength="20"
                :readonly="readonly"
                @keyup="editedItem.remaining_payment = addTS($event)"
                @keypress="isNumber($event)"
                label="Remaining Payment"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-autocomplete
                v-model="editedItem.mode_of_payment"
                :items="paymentModes"
                item-text="text"
                item-value="value"
                dense
                outlined
                :readonly="readonly"
                :disabled="readonly"
                :rules="readonly ? [] : validationRules.selectRule"
                label="Mode of Payment *"
            ></v-autocomplete>
          </v-col>
          <template v-if="isChequePayment">
            <v-col cols="12" sm="12">
              <v-text-field
                  dense
                  outlined
                  :readonly="readonly"
                  :rules="readonly ? [] : validationRules.chequeNumberRules"
                  v-model="editedItem.cheque_number"
                  maxLength="50"
                  label="Cheque Number *"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-autocomplete
                  v-model="editedItem.bank_name"
                  :items="banksFilter"
                  item-text="full_name"
                  item-value="full_name"
                  dense
                  outlined
                  :loading="isBanksLoaded"
                  :readonly="readonly"
                  :disabled="readonly"
                  :rules="readonly ? [] : validationRules.bankNameRules"
                  label="Bank Name *"
                  no-data-text="Type to search banks"
                  @keyup="banksFilterKeyUp"
                  @focus="loadBanksList(editedItem.bank_name || '')"
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>
                                          <h6>
                                            <span>{{ data.item.full_name }}</span>
                                            <v-chip
                                                v-if="Number(data.item.is_verified) === 1"
                                                x-small
                                                color="success"
                                                class="ml-1"
                                                dark
                                            >Verified</v-chip>
                                          </h6>
                                          <p v-if="data.item.uid">ID: {{ String(data.item.uid).toUpperCase() }}</p>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12">
              <v-text-field
                  dense
                  outlined
                  type="date"
                  :readonly="readonly"
                  :rules="readonly ? [] : validationRules.chequeDateRules"
                  v-model="editedItem.cheque_date"
                  label="Cheque Date *"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-autocomplete
                  v-model="editedItem.is_cashable"
                  :items="cashableOptions"
                  item-text="text"
                  item-value="value"
                  dense
                  outlined
                  :readonly="readonly"
                  :disabled="readonly"
                  :rules="readonly ? [] : validationRules.selectRule"
                  label="Cashable / Non-Cashable *"
              ></v-autocomplete>
            </v-col>
          </template>
          <v-col cols="12" sm="6">
            <v-text-field
                dense
                outlined
                :readonly="readonly"
                :rules="readonly ? [] : validationRules.priceRules"
                v-model="editedItem.price"
                maxLength="20"
                @keyup="editedItem.price = addTS($event); onReservationAmountInput()"
                @keypress="isWholeNumber($event)"
                label="Reservation Amount *"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
                dense
                outlined
                :readonly="readonly"
                :rules="readonly ? [] : validationRules.percentageRules"
                v-model="editedItem.price_percentage"
                maxLength="10"
                @input="onReservationPercentInput"
                @keypress="isWholeNumber($event)"
                label="Reservation (%) *"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions v-if="!readonly">
        <v-spacer></v-spacer>
        <v-btn
            :disabled="!validationRules.valid"
            color="blue darken-1"
            text
            @click="saveItem(editedItem)"
        >
          Save
        </v-btn>
      </v-card-actions>
      <v-col cols="12">
        <div v-if="errors!=undefined && errors.length >= 0"
             role="alert"
             v-bind:class="{ show: errors.length }"
             class="alert fade alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapState} from "vuex";
import {CLEAR_LISTINGS_ERRORS, RESERVE_UNIT} from "@/core/services/store/listings.module";
import reservationFlowMixin from "@/mixins/reservationFlowMixin";

export default {
  name: 'reserve-unit',
  mixins: [reservationFlowMixin],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editedItem: {},
      ownersFilter: [],
      isOwnersLoaded: false,
      validationRules: {
        valid: true,
        blockingAmountRules: [
          v => !!v || "This field is required",
          v => (v && this.stripNumeric(v).length >= 1) || "Must be greater than 0",
          v => (v && this.stripNumeric(v).length <= 20) || "Must be less than or equals to 20 characters",
          v => !this.salePriceAmount || parseFloat(this.stripNumeric(v)) <= this.salePriceAmount || "Cannot exceed sale price"
        ],
        priceRules: [
          v => !!v || "This field is required",
          v => (v && this.stripNumeric(v).length >= 1) || "Must be greater than 0",
          v => (v && this.stripNumeric(v).length <= 20) || "Must be less than or equals to 20 characters",
          v => !this.salePriceAmount || parseFloat(this.stripNumeric(v)) <= this.salePriceAmount || "Cannot exceed sale price"
        ],
        percentageRules: [
          v => !!v || "This field is required",
          v => (v && parseFloat(this.stripNumeric(v)) >= 0) || "Must be 0 or greater",
          v => (v && parseFloat(this.stripNumeric(v)) <= 100) || "Must be less than or equals to 100"
        ],
        chequeNumberRules: [
          v => !!v || "Cheque number is required",
          v => (v && v.length <= 50) || "Must be less than or equals to 50 characters"
        ],
        bankNameRules: [
          v => !!v || "Bank name is required",
          v => (v && v.length <= 100) || "Must be less than or equals to 100 characters"
        ],
        chequeDateRules: [
          v => !!v || "Cheque date is required"
        ],
        selectRule: [
          (v) => {
            if (v === null || v === undefined || v === '')
              return 'Select an option';
            else return true;
          }
        ],
        multipleRules: [
          v => {
            if (!v || v.length < 1) return "Select Buyer(s)";
            else return true;
          }
        ]
      },
    }
  },
  mounted() {
    if (this.readonly) {
      this.initializeViewForm();
    } else {
      this.initializeReserveForm();
    }
  },
  watch: {
    item: {
      deep: true,
      handler(newItem, oldItem) {
        if (this.readonly) {
          this.handleViewItemChange(newItem, oldItem);
        } else {
          this.handleReserveItemChange(newItem, oldItem);
        }
      },
    },
  },
  methods: {
    saveItem(ritem) {
      if (this.$refs.ru_form.validate()) {
        const payload = this.buildReservationPayload(ritem, 1);
        this.$store.dispatch(CLEAR_LISTINGS_ERRORS);
        this.$store.dispatch(RESERVE_UNIT, {'slug': this.item.id, data: payload}).then(() => {
          this.resetReservationForm();
          this.$emit('resDClose')
        })
      }
    }
  },
  computed: {
    ...mapState({
      errors: state => state.listings.errors
    })
  }
}
</script>
